'use strict';

/**
 * Error Service
 *
 * @version
 * 13.9.0 PRDS-354 Add disappear timer for info box popup
 * 13.8.0 MLIBJS-176 Add the info popup to toastr
 * 13.2.0 MLIBJS-157 console.logs appearing when updating order attachments
 * 12.4.0 #756 MLIBJS-121 Add validation to export wdErrorService for ES6 usage
 * 5.9.0 #400 Standardise wdErrorService
 * 5.3.1 #314 Convert Error Message Objects
 * 5.3.0 #311 Add 'search_value'
 * 3.2.0 #261 Unit Test Coverage, Tidy
 * 2.2.0 #229 Remove React Deprecation Warning
 * 2.2.0 #227 Add Basic Error Service
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @author Monika Gole <monika.gole@ncircletech.com>
 *
 * @copyright (c) 2015-2023 Build Centrix
 */
var wdErrorService = angular.module('wd.error', [])
    .factory('wdErrorService', ['wdToastrHandler', 'wdSharedFunctionsService',
        function (wdToastrHandler, wdSharedFunctionsService) {

            var service = {};

            var fatalErrors = [];

            // How Many Errors Should Be Displayed?
            service.fatalErrorDisplayLimit = 3;

            // Default URLS
            service.singleSignOnUrl = null;

            /**
             * Toaster Default & Custom Options
             * See Demo for Options: http://codeseven.github.io/toastr/demo.html
             */
            wdToastrHandler.options = {
                debug: false,
                newestOnTop: false,
                positionClass: 'toast-bottom-right',
                preventDuplicates: false,
                onclick: null,
                showDuration: '300',
                hideDuration: '1000',
                extendedTimeOut: 0,
                showEasing: 'swing',
                hideEasing: 'linear',
                showMethod: 'fadeIn'
            };

            /**
             * Defult Message Appearance Basedon Message Type
             */
            var messages = {

                msgClose: {
                    closeButton: true,
                    progressBar: false,
                    timeOut: 0,
                    tapToDismiss: true
                },

                msgFade: {
                    closeButton: false,
                    progressBar: true,
                    timeOut: '3000',
                    tapToDismiss: true
                },

                msgUserInfo: {
                    closeButton: true,
                    progressBar: true,
                    timeOut: '5000',
                    tapToDismiss: false
                }

            };

            /**
             * Clear Fatal Errors
             * 
             * @returns {Array}
             */
            service.clearErrors = function () {

                fatalErrors = [];
                return fatalErrors;

            };

            /**
             * Check a response for Errors and add them to a Fatal Errors Array
             * 
             * @since 5.9.0
             * @param response
             * @param operation
             */
            service.checkResponseForErrors = function (response, operation) {

                if (response.status === 4010 && service.singleSignOnUrl) {

                    // Redirect to Single Sign On
                    wdSharedFunctionsService.redirectToUrl(service.singleSignOnUrl, true, 0);

                } else {

                    // Add Error to Array
                    service.fatalError(operation, response.status, response.statusText);

                }
            };

            /**
             * Add Fatal Error
             * 
             * @since 5.9.0
             * @param operation
             * @param code
             * @param message
             */
            service.fatalError = function (operation, code, message) {

                fatalErrors.push(
                    {
                        operation: 'Error while ' + operation,
                        code: code,
                        message: message
                    }
                );

            };

            /**
             * Get Fatal Error Display Limit
             * 
             * @since 5.9.0
             * @returns {*|number}
             */
            service.getFatalErrorDisplayLimit = function () {

                return service.fatalErrorDisplayLimit;

            };

            /**
             * Get Fatal Errors
             * 
             * @since 5.9.0
             * @returns {Array}
             */
            service.getFatalErrors = function () {

                return fatalErrors;

            };

            /**
             * Set Error Display Limit
             * 
             * @since 5.9.0
             * @param limit
             */
            service.setFatalErrorDisplayLimit = function (limit) {

                service.fatalErrorDisplayLimit = limit;

            };

            /**
             * Set the Url we redirect to in case of Errors
             *
             * @since 5.9.0
             * @param url
             */
            service.setSingleSignOnUrl = function (url) {

                service.singleSignOnUrl = url;

            };

            /**
             * User output error message
             * 
             * @since 5.9.0
             * @param title
             * @param message
             * @returns {boolean}
             */
            service.userError = function (title, message) {

                message = typeof message === 'object' ? JSON.stringify(message) : message;
                wdToastrHandler.error(message, title, messages.msgClose);
                return true;

            };

            /**
             * User output message
             * 
             * @since 5.9.0
             * @param title
             * @param message
             * @returns {boolean}
             */
            service.userSuccess = function (title, message) {

                message = typeof message === 'object' ? JSON.stringify(message) : message;
                wdToastrHandler.success(message, title, messages.msgFade);
                return true;

            };

            /**
             * User info message
             * 
             * @since 13.8.0
             * @param title
             * @param message
             * @returns {boolean}
             */
            service.userInfo = function (title, message) {

                message = typeof message === 'object' ? JSON.stringify(message) : message;
                wdToastrHandler.info(message, title, messages.msgUserInfo);
                return true;

            };

            return service;

        }]);
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdErrorService;
}
// EOF
